import { useAppContext } from 'Context/AppContext';
import { HomeroomTeacherClassYearIncome, ListStudentIncome, SubjectTeacherClassYearIncome } from './tab';

export const IncomeInfo = () => {
    const { tabNumber } = useAppContext();

    if (tabNumber === 0) return <ListStudentIncome />;
    if (tabNumber === 1) return <HomeroomTeacherClassYearIncome />;
    if (tabNumber === 2) return <SubjectTeacherClassYearIncome />;

    return <></>;
};
